import React, { ComponentProps, ReactNode } from 'react';
import { Label, Tag } from '@innovationnorway/cl-react';

type LabelWithTagProps = {
  className?: string;
  children: ReactNode;
  'data-color'?: ComponentProps<typeof Tag>['data-color'];
  tagText: string;
};

const DEFAULT_CLASS =
  'display--flex flex-direction--row align-items--center gap--1 justify-content--space-between';

const LabelWithTag = ({ className, children, 'data-color': tagColor, tagText }: LabelWithTagProps) => {
  const mergedClassName = className ? `${DEFAULT_CLASS} ${className}` : DEFAULT_CLASS;
  return (
    <Label className={mergedClassName}>
      {children}
      <Tag data-color={tagColor} style={{ fontWeight: 'normal', flexShrink: 0, whiteSpace: 'nowrap' }}>
        {tagText}
      </Tag>
    </Label>
  );
};

export default LabelWithTag;
